import * as React from 'react';
import { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { History } from 'history';
import Dashboard from './dashboard';
import DatabaseSetup from './database/setup';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';
import InfoPageForm from './pages/Form';
import {
    DASHBOARD_PATH,
    DATABASE_UPDATE_PATH,
    DATABASE_CREATE_PATH,
    PAGE_CREATE_PATH,
    PAGE_UPDATE_PATH,
    PROFILE_EDIT,
} from '../constants';
import Profile from './profile';

import {
    getAccountDetails,
    getPendingPartnersCount,
    IOrganization,
    IAccountDetails,
    IAlerts,
} from '../services/account';
import { count as getPendingPartnerCount } from '../services/partner';
import { IAvatar } from '../services/documents';
import { getPersonalMessages, getOrganizationMessages, IInboxItem } from '../services/messages';
import { getPending as getPendingPages, IPage } from '../services/pages';
import { isEmpty } from '../util';

export default (props: { history: History; location: Location; match: any }) => {
    const [organization, setOrganization] = useState<IOrganization | null>();
    const [avatar, setAvatar] = useState<IAvatar | null>();
    const [accountDetails, setAccountDetails] = useState<IAccountDetails | null>();
    const [alerts, setAlerts] = useState<IAlerts>({
        messages: 0,
        partners: 0,
        info: 0,
    });

    const loadAccountDetails = async () => {
        const result = await getAccountDetails();
        if (!result.accountDetails) return;
        await setAccountDetails(result.accountDetails);
        await setOrganization(result.accountDetails.organization);
        // TODO why object?
        await setAvatar({
            accountName: '',
            created: 0,
            fileName: '',
            url: result.accountDetails.organization.avatar,
            userName: '',
        });
    };

    const loadAlerts = async () => {
        // TODO do individual requests asynchronously?
        let msgsCount = 0;
        // const personalMsgs = await getPersonalMessages();
        // if (personalMsgs.success && !isEmpty(personalMsgs.messages))
        //     // @ts-ignore
        //     msgsCount += personalMsgs.messages.length;

        const orgMsgs = await getOrganizationMessages();
        if (orgMsgs.success && !isEmpty(orgMsgs.inbox))
            msgsCount += orgMsgs.inbox ? orgMsgs.inbox.filter((x) => !x.read).length : 0;
        const fetchedPendingPartners = await getPendingPartnerCount();
        // if (fetchedPendingPartners.partners) {
        //     const pending = fetchedPendingPartners.partners.filter(p => p.direction !== 'outgoing')
        setAlerts({
            info: await getPageAlertCount(),
            messages: msgsCount,
            partners: fetchedPendingPartners.count,
        });
    };

    const getPageAlertCount = async () => {
        const res = await getPendingPages();
        const pages = res.success && !isEmpty(res.pages) ? res.pages : [];
        return (pages || []).filter(
            (x) => (x.direction === 'incoming' || x.accountName === x.partnerName) && x.status === 'reviewing'
        ).length;
    };

    const updateAlertCounts: IUpdateAlertCounts = async (counts) => {
        const tempAlerts = { ...alerts };
        if (counts.info !== undefined) {
            tempAlerts.info = counts.info === null ? await getPageAlertCount() : counts.info;
        }
        if (counts.messages !== undefined) {
            tempAlerts.messages = counts.messages;
        }
        if (counts.partners !== undefined) {
            tempAlerts.partners = counts.partners;
        }
        return setAlerts(tempAlerts);
    };

    useEffect(() => {
        loadAccountDetails();
        loadAlerts();
    }, []);

    return (
        <React.Fragment>
            <NavBar history={props.history} organization={organization} avatar={avatar} />
            <Switch>
                <Route path={DASHBOARD_PATH}>
                    <Dashboard
                        location={props.location}
                        organization={organization}
                        accountDetails={accountDetails}
                        avatar={avatar}
                        alerts={alerts}
                        updateAlertCounts={updateAlertCounts}
                    />
                </Route>
                <Route path={DATABASE_UPDATE_PATH(':databaseName')} component={DatabaseSetup} />
                <Route path={DATABASE_CREATE_PATH} component={DatabaseSetup} />
                <Route path={PAGE_CREATE_PATH(':databaseName')} component={InfoPageForm} />
                <Route path={PAGE_UPDATE_PATH(':pageName')} component={InfoPageForm} />
                <Route path={PROFILE_EDIT}>
                    <Profile avatar={avatar} />
                </Route>
            </Switch>
            <Footer history={props.history} />
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/client/root.tsx